export { default } from './staggered-card';
export { default as staggeredCardConfig } from './staggered-card.config';
